import { render } from "./insure-daily-plan.vue?vue&type=template&id=19f6c42c&scoped=true&ts=true"
import script from "./insure-daily-plan.vue?vue&type=script&lang=ts"
export * from "./insure-daily-plan.vue?vue&type=script&lang=ts"

import "./insure-daily-plan.vue?vue&type=style&index=0&id=19f6c42c&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f6c42c"]])

export default __exports__